export default "__VITE_ASSET__fd014145__"